import React from "react";

/**
 * Salary types shown on pay-rate forms: fixed / recurring allowance lines (+ gross total for reference).
 * Excludes pure computed totals except PAY_BILL_GROSS_SALARY (sheet gross / legacy Salary PM).
 */
export function filterPayRateSalaryTypes(list) {
  if (!list || !list.length) return [];
  return list
    .filter(
      (t) =>
        t &&
        !t.Is_Deleted &&
        t.Is_Active !== false &&
        (t.SType === "Allowance" || t.Name === "PAY_BILL_GROSS_SALARY")
    )
    .sort((a, b) => (a.SortOrder || 0) - (b.SortOrder || 0));
}

/**
 * amounts: { [salaryTypeId]: string | number }
 */
export function PayRateAmountFields({ salaryTypes, amounts, onAmountChange, disabled }) {
  if (!salaryTypes?.length) {
    return (
      <p className="text-muted" style={{ fontSize: "14px" }}>
        No salary types loaded. Ensure Salary Types are configured for this school.
      </p>
    );
  }
  return (
    <div className="row">
      {salaryTypes.map((st) => (
        <div className="col-md-4" key={st.ID}>
          <div className="form-group mb-3">
            <label title={st.Name || ""}>{st.DisplayName || st.Name}</label>
            <input
              type="number"
              step="0.01"
              className="form-control"
              disabled={disabled}
              value={amounts[st.ID] === undefined || amounts[st.ID] === null ? "" : amounts[st.ID]}
              onChange={(e) => onAmountChange(st.ID, e.target.value)}
            />
          </div>
        </div>
      ))}
    </div>
  );
}

export function formatDateInput(isoOrDate) {
  if (isoOrDate == null || isoOrDate === "") return "";
  try {
    const d = typeof isoOrDate === "string" ? new Date(isoOrDate) : isoOrDate;
    if (isNaN(d.getTime())) return "";
    return d.toISOString().slice(0, 10);
  } catch {
    return "";
  }
}
